export default __webpack_public_path__ + "static/media/volcano_volcan_1.107816b3.png";